<div class="notification-item" *ngIf="showNotification">
	<div class="clearfix flex">
		<div class="col-1 col-icon center items-center flex">
			<mat-icon class="notification-icon">circle_notifications</mat-icon>
		</div>
		<div class="col-10 col-content">
			<strong class="notification-title" [title]="notification.name">
				{{ notification.name }}
			</strong>
			<span class="notification-content" [innerHtml]="notification.description"></span>
			<span class="notification-date text-muted">{{
				notification.created_at | date: 'y-MM-dd h:mm a'
			}}</span>
		</div>
	</div>
	<div class="notification-actions" (click)="markAsRead()">
		<mat-icon title="Cerrar notificación">cancel</mat-icon>
	</div>
</div>
